var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, state } from 'lit/decorators.js';
import { SdsDatePickerItem, } from '../../shared/sds-datepicker-item/sds-datepicker-item.lit';
import '../../shared/sds-datepicker-item/sds-datepicker-item.lit';
import { formatYear, getFirstYearInCalendar, getPageIndexForSelectedYear, } from '../year-picker-calculations';
import styles from './year-page-view.lit.scss';
import { sdsCustomElement } from '../../../utilities/custom-components';
/**
 * Control represents a page view for the year-picker
 */
let SdsYearPageView = (() => {
    var _SdsYearPageView__pageIndex_accessor_storage, _SdsYearPageView_currentYear_accessor_storage, _SdsYearPageView_stateMapper_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-year-page-view')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let __pageIndex_decorators;
    let __pageIndex_initializers = [];
    let __pageIndex_extraInitializers = [];
    let _currentYear_decorators;
    let _currentYear_initializers = [];
    let _currentYear_extraInitializers = [];
    let _stateMapper_decorators;
    let _stateMapper_initializers = [];
    let _stateMapper_extraInitializers = [];
    var SdsYearPageView = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsYearPageView__pageIndex_accessor_storage.set(this, __runInitializers(this, __pageIndex_initializers, 0));
            _SdsYearPageView_currentYear_accessor_storage.set(this, (__runInitializers(this, __pageIndex_extraInitializers), __runInitializers(this, _currentYear_initializers, void 0)));
            _SdsYearPageView_stateMapper_accessor_storage.set(this, (__runInitializers(this, _currentYear_extraInitializers), __runInitializers(this, _stateMapper_initializers, () => 'none')));
            this._itemsNumber = (__runInitializers(this, _stateMapper_extraInitializers), 20);
            // TODO: there should be a better way to do this, first year in calendar shouldn't depend on the current year
            this._firstYearInCalendar = getFirstYearInCalendar(this._itemsNumber);
            this._items = [];
            this.itemClickHandler = (event) => {
                if (event.target instanceof SdsDatePickerItem) {
                    this.dispatchEvent(new CustomEvent(SdsYearPageView.SELECT_EVENT, {
                        detail: { year: parseInt(event.target.value) },
                    }));
                }
            };
            this.itemKeyPressHandler = (event) => {
                if (event.key === 'Enter' && event.target instanceof SdsDatePickerItem) {
                    this.dispatchEvent(new CustomEvent(SdsYearPageView.SELECT_EVENT, {
                        detail: { year: parseInt(event.target.value) },
                    }));
                }
            };
            this.handleHover = (event) => {
                let hoveredYear;
                if (event.target instanceof SdsDatePickerItem) {
                    hoveredYear = parseInt(event.target.value);
                }
                this.dispatchEvent(new CustomEvent(SdsYearPageView.HOVER_EVENT, {
                    detail: { hoveredYear },
                }));
            };
        }
        get _pageIndex() { return __classPrivateFieldGet(this, _SdsYearPageView__pageIndex_accessor_storage, "f"); }
        set _pageIndex(value) { __classPrivateFieldSet(this, _SdsYearPageView__pageIndex_accessor_storage, value, "f"); }
        get currentYear() { return __classPrivateFieldGet(this, _SdsYearPageView_currentYear_accessor_storage, "f"); }
        set currentYear(value) { __classPrivateFieldSet(this, _SdsYearPageView_currentYear_accessor_storage, value, "f"); }
        get stateMapper() { return __classPrivateFieldGet(this, _SdsYearPageView_stateMapper_accessor_storage, "f"); }
        set stateMapper(value) { __classPrivateFieldSet(this, _SdsYearPageView_stateMapper_accessor_storage, value, "f"); }
        get pageIndex() {
            return this._pageIndex;
        }
        set pageIndex(value) {
            this._pageIndex = value;
            this.dispatchEvent(new CustomEvent(SdsYearPageView.PAGE_CHANGE_EVENT, {
                detail: {
                    pageIndex: value,
                    firstYearInPage: this._firstYearInCalendar + value * this._itemsNumber,
                    lastYearInPage: this._firstYearInCalendar + (value + 1) * this._itemsNumber - 1,
                },
            }));
        }
        get itemsNumber() {
            return this._itemsNumber;
        }
        openPageFor(year) {
            this.pageIndex = getPageIndexForSelectedYear(year, this._firstYearInCalendar, this._itemsNumber);
        }
        openPageInitialPage() {
            this.pageIndex = 0;
        }
        goByPage(diff) {
            this.pageIndex += diff;
        }
        render() {
            return html `
            <div
                id="content-container"
                class="sds-year-picker"
                @click="${this.itemClickHandler}"
                @keypress="${this.itemKeyPressHandler}"
                @mouseover="${this.handleHover}"
            >
                ${this.renderItems()}
            </div>
        `;
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        /**
         * state mapper for year, the result is delegated to sds-datepicker-item
         */
        setYearStateMapper(stateMapper) {
            this.stateMapper = stateMapper;
            this.updateStates();
            this.requestUpdate('stateMapper');
        }
        async updated() {
            await this.updateComplete;
            this.setItems();
        }
        async firstUpdated() {
            await this.updateComplete;
            this.initContentContainer();
        }
        initContentContainer() {
            var _a;
            const contentContainer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#content-container');
            if (contentContainer) {
                this._contentContainer = contentContainer;
            }
        }
        setItems() {
            this._items = Array.from(this._contentContainer.querySelectorAll('sds-datepicker-item').values());
        }
        renderItems() {
            const items = [];
            for (let i = 0; i < this.itemsNumber; ++i) {
                items.push(this.getItemTemplate(this._firstYearInCalendar + this.pageIndex * this.itemsNumber + i));
            }
            return items;
        }
        getItemTemplate(year) {
            const currentYear = this.currentYear ? this.currentYear : new Date().getFullYear();
            return html ` <sds-datepicker-item
            class="sds-date-picker-item"
            value="${formatYear(year)}"
            identifier="${year}"
            state="${this.stateMapper(year)}"
            ?current="${currentYear === year}"
        ></sds-datepicker-item>`;
        }
        updateStates() {
            this._items.forEach(item => item.setAttribute('state', this.stateMapper(parseInt(item.identifier))));
        }
    };
    _SdsYearPageView__pageIndex_accessor_storage = new WeakMap();
    _SdsYearPageView_currentYear_accessor_storage = new WeakMap();
    _SdsYearPageView_stateMapper_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsYearPageView");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        __pageIndex_decorators = [state()];
        _currentYear_decorators = [property({ reflect: true, attribute: 'current-year', type: Number })];
        _stateMapper_decorators = [state()];
        __esDecorate(_classThis, null, __pageIndex_decorators, { kind: "accessor", name: "_pageIndex", static: false, private: false, access: { has: obj => "_pageIndex" in obj, get: obj => obj._pageIndex, set: (obj, value) => { obj._pageIndex = value; } }, metadata: _metadata }, __pageIndex_initializers, __pageIndex_extraInitializers);
        __esDecorate(_classThis, null, _currentYear_decorators, { kind: "accessor", name: "currentYear", static: false, private: false, access: { has: obj => "currentYear" in obj, get: obj => obj.currentYear, set: (obj, value) => { obj.currentYear = value; } }, metadata: _metadata }, _currentYear_initializers, _currentYear_extraInitializers);
        __esDecorate(_classThis, null, _stateMapper_decorators, { kind: "accessor", name: "stateMapper", static: false, private: false, access: { has: obj => "stateMapper" in obj, get: obj => obj.stateMapper, set: (obj, value) => { obj.stateMapper = value; } }, metadata: _metadata }, _stateMapper_initializers, _stateMapper_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsYearPageView = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.SELECT_EVENT = 'sds.year-page-view.select';
    _classThis.HOVER_EVENT = 'sds.year-page-view.hovered';
    _classThis.PAGE_CHANGE_EVENT = 'sds.year-page-view.page-changed';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsYearPageView = _classThis;
})();
export { SdsYearPageView };
